'use client';

import { EllipsisVertical } from 'lucide-react';
import MenuComponent from '@mui/material/Menu';
import { PropsWithChildren, useState } from 'react';

import { Button } from '../../../../../Button';
import Item from './Item';

const Menu = ({ children }: PropsWithChildren) => {
	const [menuAnchorElement, setMenuAnchorElement] = useState<HTMLButtonElement | undefined>();

	return (
		<>
			<Button variant="ghost" size="lg-icon-in-button" onClick={(e) => setMenuAnchorElement(e.currentTarget)}>
				<EllipsisVertical size={24} />
			</Button>
			<MenuComponent
				anchorEl={menuAnchorElement}
				open={!!menuAnchorElement}
				onClose={() => setMenuAnchorElement(undefined)}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				elevation={1}
			>
				{children}
			</MenuComponent>
		</>
	);
};

Menu.Item = Item;

export default Menu;
